__turbopack_context__.v({
  "bankDetails": "BankDetails-module-scss-module__SfFM2W__bankDetails",
  "title": "BankDetails-module-scss-module__SfFM2W__title",
});
